// src/api/designationApi.ts
import api from './api';

export interface Designation {
  id?: number;
  name: string;
  description: string;
}

const designationApi = {
  // Add Designation
  addDesignation: async (designationData: Omit<Designation, 'id'>) => {
    try {
      const response = await api.post('/add_designation', designationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get All Designations
  getDesignations: async () => {
    try {
      const response = await api.get('/get_designations');
      console.log('Designations API response:', response.data); // Debug log
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get Designation By Id
  getDesignationById: async (designationId: number) => {
    try {
      const response = await api.get(`/get_designation/${designationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update Designation
  updateDesignation: async (designationId: number, designationData: Partial<Designation>) => {
    try {
      const response = await api.put(`/update_designation/${designationId}`, designationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete Designation
  deleteDesignation: async (designationId: number) => {
    try {
      const response = await api.delete(`/delete_designation/${designationId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default designationApi;